import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-content-head" }
const _hoisted_3 = {
  class: "gfu-hd gfu-hd--h1",
  "data-qa": "page-title"
}
const _hoisted_4 = { class: "gfu-box gfu-box--huge _mb-3 gfu-bt gfu-bt--b1" }
const _hoisted_5 = { class: "gfu-hd gfu-hd--h2 _mt-2" }
const _hoisted_6 = { class: "gfu-bullet-list" }
const _hoisted_7 = ["href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_footer_navigation = _resolveComponent("footer-navigation")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_footer_navigation, {
      "current-page": _ctx.Resources.Layout.TermsOfServiceLink,
      "group-type": ['system']
    }, null, 8 /* PROPS */, ["current-page"]),
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.Resources.TermsOfService.PageHeader), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", null, _toDisplayString(_ctx.Resources.TermsOfService.PageDescription), 1 /* TEXT */),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.termsList, (term) => {
          return (_openBlock(), _createElementBlock("div", {
            key: term.title
          }, [
            _createElementVNode("h2", _hoisted_5, _toDisplayString(term.title), 1 /* TEXT */),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(term.items, (item) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: item.name,
                  class: "gfu-bullet-list__item"
                }, [
                  _createElementVNode("a", {
                    href: item.url,
                    class: "gfu-link gfu-link--accent"
                  }, _toDisplayString(item.name), 9 /* TEXT, PROPS */, _hoisted_7)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ])
  ]))
}